export default {
  // OutgoingPhone
  callingNumber: '발신번호',
  explanation: '설명',
  registrationDate: '등록일시',
  state: '상태',
};
